var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M15.5 10.5c0-3.1 2.5-5.7 5.7-5.7h11M39.3 12.1v13M32.2 4.9l7.1 7.2M31.3 6.2v6.7h7.1M15 16.6l5.5 5.5-5.5 5.4M19 22.1H7.2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 2.5,
    cy: 22,
    r: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M29.8 21.5c-.8 3.6-3.2 12-6.2 15.2s-5.4.7-5.1-.4c.6-2.8 3.3-3.4 9.5-4.9 6.2-1.4 8.4-1.7 9.3-1.5 2.6.5 3.3 2.7 2.4 3.4-1 .9-2.7 1-4.2.2s-8.1-6.5-9.4-11.3c-1.6-3.5 1.3-4.1 1.5-4.1.2 0 3-.2 2.2 3.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportPdf);
export default __webpack_public_path__ + "static/media/exportPdf.1665143b01760df3b05013436bf21f65.svg";
export { ForwardRef as ReactComponent };